<template>
    <div class="friendZone">
        <div class="zoneHeader">
            <slot name="header"></slot>
        </div>
        <div v-if="showPanel" class="displayArea">
            <PortfoliosTotal :total="total" class="displayAreaHeader"></PortfoliosTotal>
            <div v-if="display === 'portfolios'">
                <PortfolioStockList :data="portfolioStockList" :owner="owner"></PortfolioStockList>
            </div>
            <div v-else-if="display === 'transactions'">
                <TransactionList :transactionList="transactionList"></TransactionList>
            </div>
            <div v-else-if="display === 'distribution'">
                <HoldingsPieChart :positions="positions"></HoldingsPieChart>
            </div>
        </div>
        <div v-else class="zoneMessage">{{ $t('friendZone.noInformationSharedByFriend') }}</div>
    </div>
</template>

<script>
import HoldingsPieChart from '../../components/controls/HoldingsPieChart.vue'
import PortfolioStockList from '../../components/portfolio/PortfolioStockList.vue'
import PortfoliosTotal from '../../components/portfolio/PortfoliosTotal.vue'
import TransactionList from '../../components/portfolio/TransactionList.vue'
import DataPackage from '../../models/DataPackage';
export default {
	components: { PortfoliosTotal, PortfolioStockList, TransactionList, HoldingsPieChart },
    props: {
        display: {
            type: String
        },
        data: {
            type: DataPackage
        }
    },
    computed: {
        total() {
            return this.data ? this.data.portfoliosChangeInfo : {};
        },
        owner() {
            return this.data ? this.data.owner : '';
        },
        portfolioStockList() {
            return this.data ? this.data.positions : [];
        },
        transactionList() {
            return this.data ? this.data.transactions : [];
        },
        positions() {
            return this.data ? this.data.positions : [];
        },
        showPanel() {
            if (this.data) {
                if (this.data.owner === 'me') return true;
                if (this.data.sharingOptions && this.positions.length > 0) {
                    return this.data.sharingOptions.portfolios.active || this.data.sharingOptions.transactions.active;
                }
            }
            return false;
        }
    }
}
</script>

<style lang="scss" scoped>
.friendZone {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 50%;
    height: 100%;
    padding: 10px;
    .zoneHeader {
        height: 60px;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        .zhName {}
        .zhActions {}
    }
    .displayAreaHeader {
        padding: 10px;
        border: 1px solid var(--midGray);
        border-radius: 8px;
        background-color: #FFF;
    }
    .displayArea {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    .zoneMessage {
        padding: 20px;
        border: 1px solid var(--v-agora-base);
        border-radius: 8px;
        background-color: var(--v-agorabg-base);
        text-align: center;
        font-size: 1.2em;
    }
}
</style>